class BaseModel {
  constructor(data) {
    this.data = data;
  }

  set data(data) {
    this.id = parseInt(data['id']);
  }

  compareId(id) {
    return this.id === parseInt(id);
  }
}

export default BaseModel;
